/* NSCREATION - panier coulissant. L'element s'appelle cart-drawer pour rester compatible
   avec les boutons Ajouter au panier du theme (product-form.js). */
(function () {
  if (customElements.get('cart-drawer')) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), summary';
  var UPSELL_ID = 'nsc-upsell';

  class NscCartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id') || 'nsc-cart';
      this.upsellId = UPSELL_ID;
      this.autoOpen = this.getAttribute('data-auto-open') !== 'false';
      this.activeElement = null;
      this.busy = false;

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onEditorOpen = this.onEditorOpen.bind(this);
      this.onEditorClose = this.onEditorClose.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      document.addEventListener('keydown', this.onKeydown);
      /* Editeur Shopify : le panier s'ouvre quand on selectionne la section Panier ou Upsell */
      document.addEventListener('shopify:section:select', this.onEditorOpen);
      document.addEventListener('shopify:section:load', this.onEditorOpen);
      document.addEventListener('shopify:section:deselect', this.onEditorClose);

      this.mountUpsell();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:section:select', this.onEditorOpen);
      document.removeEventListener('shopify:section:load', this.onEditorOpen);
      document.removeEventListener('shopify:section:deselect', this.onEditorClose);
      document.documentElement.classList.remove('nsc-cart-lock');
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    onEditorOpen(event) {
      var id = event.detail && event.detail.sectionId;
      if (id === this.upsellId) this.mountUpsell();
      if (id === this.sectionId || id === this.upsellId) this.open();
    }

    onEditorClose(event) {
      var id = event.detail && event.detail.sectionId;
      if (id === this.sectionId || id === this.upsellId) this.close();
    }

    /* Interface attendue par product-form.js */
    getSectionsToRender() {
      return [
        { id: this.sectionId, selector: '[data-nsc-cart-inner]' },
        { id: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: this.upsellId, selector: '[data-nsc-upsell-inner]' }
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(state) {
      this.applySections((state && state.sections) || {});
      if (this.autoOpen) this.open();
    }

    open(trigger) {
      if (trigger) this.activeElement = trigger;
      if (this.isOpen) return;
      this.classList.add('is-open');
      document.documentElement.classList.add('nsc-cart-lock');
      var panel = this.querySelector('.nsc-cart__panel');
      window.setTimeout(function () {
        var target = panel && (panel.querySelector('.nsc-cart__close') || panel);
        if (target) target.focus({ preventScroll: true });
      }, 60);
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('nsc-cart-lock');
      if (this.activeElement && document.contains(this.activeElement)) {
        try {
          this.activeElement.focus({ preventScroll: true });
        } catch (error) {}
      }
    }

    /* Place l'upsell (section Upsell panier) en bas de la liste des articles.
       html = rendu serveur de la section ; sans html on reprend la copie presente dans la page. */
    mountUpsell(html) {
      var body = this.querySelector('.nsc-cart__body');
      if (!body) return;

      var node = null;
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        node = doc.querySelector('[data-nsc-upsell-inner]');
      } else {
        node = document.querySelector('[data-nsc-upsell-source] [data-nsc-upsell-inner]');
      }

      var slot = body.querySelector('.nsc-upsell-slot');
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'nsc-upsell-slot';
        body.appendChild(slot);
      }
      slot.innerHTML = node ? node.outerHTML : '';
      this.initUpsellCarousel(slot);
    }

    /* Carrousel de l'upsell : fleches, glisser a la souris (PC) ; le doigt fonctionne deja sur mobile */
    initUpsellCarousel(slot) {
      var root = slot.querySelector('.nsc-upsell--scroll');
      var list = root && root.querySelector('.nsc-upsell__list');
      var items = list ? list.querySelectorAll('.nsc-upsell__item') : [];
      if (!list || items.length < 2) return;

      function stepWidth() {
        var style = window.getComputedStyle(list);
        var gap = parseFloat(style.columnGap || style.gap) || 10;
        return items[0].offsetWidth + gap;
      }

      function makeArrow(direction, glyph, label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'nsc-upsell__arrow';
        button.setAttribute('aria-label', label);
        button.textContent = glyph;
        button.addEventListener('click', function () {
          list.scrollBy({ left: direction * stepWidth(), behavior: 'smooth' });
        });
        return button;
      }

      var prev = makeArrow(-1, '‹', 'Précédent');
      var next = makeArrow(1, '›', 'Suivant');
      var nav = document.createElement('div');
      nav.className = 'nsc-upsell__nav';
      nav.appendChild(prev);
      nav.appendChild(next);
      root.appendChild(nav);

      function update() {
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      }
      list.addEventListener('scroll', update, { passive: true });
      window.requestAnimationFrame(update);

      /* glisser-deposer a la souris */
      var pressed = false;
      var dragging = false;
      var suppressClick = false;
      var startX = 0;
      var startLeft = 0;

      list.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('select, button')) return;
        pressed = true;
        dragging = false;
        startX = event.clientX;
        startLeft = list.scrollLeft;
      });

      list.addEventListener('pointermove', function (event) {
        if (!pressed) return;
        var delta = event.clientX - startX;
        if (!dragging && Math.abs(delta) > 5) {
          dragging = true;
          list.classList.add('is-dragging');
          list.style.scrollSnapType = 'none';
          list.setPointerCapture(event.pointerId);
        }
        if (dragging) list.scrollLeft = startLeft - delta;
      });

      function endDrag(event) {
        if (!pressed) return;
        pressed = false;
        if (!dragging) return;
        dragging = false;
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 0);
        list.classList.remove('is-dragging');
        try {
          list.releasePointerCapture(event.pointerId);
        } catch (error) {}
        var width = stepWidth();
        var index = Math.round(list.scrollLeft / width);
        list.scrollTo({ left: index * width, behavior: 'smooth' });
        window.setTimeout(function () { list.style.scrollSnapType = ''; }, 400);
      }
      list.addEventListener('pointerup', endDrag);
      list.addEventListener('pointercancel', endDrag);

      list.addEventListener('click', function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    /* Remplace le contenu du panier et l'icone du header par le rendu serveur.
       La barre repart de son ancienne valeur (variable CSS --from). */
    applySections(sections) {
      var oldFill = this.querySelector('.nsc-goal__fill');
      var previous = oldFill ? parseFloat(oldFill.getAttribute('data-percent')) : NaN;

      var html = sections[this.sectionId];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-nsc-cart-inner]');
        var current = this.querySelector('[data-nsc-cart-inner]');
        if (next && current) current.innerHTML = next.innerHTML;
      }

      this.mountUpsell(sections[this.upsellId]);

      var bubbleHtml = sections['cart-icon-bubble'];
      if (bubbleHtml) {
        var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var bubbleSection = bubbleDoc.querySelector('.shopify-section');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && bubbleSection) bubble.innerHTML = bubbleSection.innerHTML;
      }

      var newFill = this.querySelector('.nsc-goal__fill');
      if (newFill && !isNaN(previous)) {
        newFill.style.setProperty('--from', previous + '%');
        newFill.addEventListener('animationend', function () {
          newFill.style.removeProperty('--from');
        }, { once: true });
      }
    }

    onClick(event) {
      var target = event.target;

      if (target.closest('[data-nsc-cart-close]')) {
        this.close();
        return;
      }

      var upsellButton = target.closest('[data-nsc-upsell-add]');
      if (upsellButton) {
        this.addUpsell(upsellButton);
        return;
      }

      var qtyButton = target.closest('[data-nsc-qty]');
      if (qtyButton) {
        var row = qtyButton.closest('.nsc-item');
        var input = row && row.querySelector('.nsc-qty__input');
        if (!input) return;
        var step = parseInt(input.getAttribute('data-step'), 10) || 1;
        var value = parseInt(input.value, 10) || 0;
        var next = qtyButton.getAttribute('data-nsc-qty') === 'plus' ? value + step : Math.max(0, value - step);
        this.changeLine(parseInt(row.getAttribute('data-line'), 10), next);
        return;
      }

      var removeButton = target.closest('[data-nsc-remove]');
      if (removeButton) {
        var item = removeButton.closest('.nsc-item');
        if (item) this.changeLine(parseInt(item.getAttribute('data-line'), 10), 0);
      }
    }

    onChange(event) {
      var input = event.target.closest('.nsc-qty__input');
      if (input) {
        var row = input.closest('.nsc-item');
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        this.changeLine(parseInt(row.getAttribute('data-line'), 10), quantity);
        return;
      }

      var note = event.target.closest('.nsc-note__field');
      if (note) this.saveNote(note.value);
    }

    sectionIds() {
      return this.getSectionsToRender().map(function (section) { return section.id; }).join(',');
    }

    changeLine(line, quantity) {
      if (this.busy || !line) return;
      var self = this;
      this.busy = true;
      this.classList.add('is-loading');

      /* Options personnalisees : les lignes d'options liees suivent la quantite du produit (suppression comprise) */
      var row = this.querySelector('.nsc-item[data-line="' + line + '"]');
      var extraKeys = row ? (row.getAttribute('data-nsc-extras') || '').split(',').filter(Boolean) : [];
      var mainKey = row ? row.getAttribute('data-key') : '';
      var url = window.routes.cart_change_url + '.js';
      var payload = { line: line, quantity: quantity };
      if (extraKeys.length && mainKey) {
        var updates = {};
        updates[mainKey] = quantity;
        extraKeys.forEach(function (key) { updates[key] = quantity; });
        url = window.routes.cart_update_url + '.js';
        payload = { updates: updates };
      }
      payload.sections = this.sectionIds();
      payload.sections_url = window.location.pathname;

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status || !result.data.sections) {
            throw new Error(result.data.description || result.data.message || window.cartStrings.error);
          }
          self.applySections(result.data.sections);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nsc-cart', cartData: result.data });
          }
        })
        .catch(function (error) {
          self.showError(line, error.message);
        })
        .then(function () {
          self.busy = false;
          self.classList.remove('is-loading');
        });
    }

    /* Ajout d'un produit propose dans l'upsell */
    addUpsell(button) {
      if (this.busy) return;
      var item = button.closest('.nsc-upsell__item');
      var select = item && item.querySelector('.nsc-upsell__select');
      var variantId = parseInt(select ? select.value : button.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      var self = this;
      this.busy = true;
      this.classList.add('is-loading');

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: this.sectionIds(),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status || !result.data.sections) {
            throw new Error(result.data.description || result.data.message || window.cartStrings.error);
          }
          self.applySections(result.data.sections);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nsc-upsell', cartData: result.data });
          }
        })
        .catch(function (error) {
          var box = item && item.querySelector('.nsc-upsell__error');
          if (box) {
            box.textContent = error.message;
            box.hidden = false;
          }
        })
        .then(function () {
          self.busy = false;
          self.classList.remove('is-loading');
        });
    }

    showError(line, message) {
      var row = this.querySelector('.nsc-item[data-line="' + line + '"]');
      var box = row && row.querySelector('.nsc-item__error');
      if (!box) return;
      box.textContent = message;
      box.hidden = false;
      var input = row.querySelector('.nsc-qty__input');
      if (input) input.value = input.getAttribute('data-current');
    }

    saveNote(value) {
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }

    /* Echap pour fermer, Tab reste dans le panier */
    onKeydown(event) {
      if (!this.isOpen) return;

      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;

      var panel = this.querySelector('.nsc-cart__panel');
      if (!panel) return;
      var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (element) {
        return element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden';
      });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (event.shiftKey && (active === first || !panel.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !panel.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('cart-drawer', NscCartDrawer);
})();